"use strict";

import React from "react";
import { Modal } from "react-bootstrap";
import SuggestedDateTime from "../../../components/SuggestedDateTime";

const SuggestedDateTimeInModal = (props)=> {
  const { open, onClose, suggestedConfTimes, mentorEmail, _updateMentorEmail,
    _saveScheduledForLaterResponse, scheduledFor, scheduledTimezone, mentorTimezone } = props;

  return (
    <Modal show={open} backdrop={true}>
      <Modal.Header closeButton={true} onHide={onClose}>
        <Modal.Title>Schedule your interview</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        { suggestedConfTimes &&
           <SuggestedDateTime
              closeModal={() => onClose()}
              suggestedConfTimes={suggestedConfTimes}
              mentorEmail={mentorEmail}
              _updateMentorEmail={_updateMentorEmail}
              _saveScheduledForLaterResponse={_saveScheduledForLaterResponse}
              scheduledFor={scheduledFor}
              scheduledTimezone={scheduledTimezone}
              mentorTimezone={mentorTimezone}
            />
        }
      </Modal.Body>
    </Modal>
  );
}

export default SuggestedDateTimeInModal;
